<template>
  <div>
    <v-card class="mx-auto" max-width="1000" elevation="0" style="margin:10px;">
      <v-row>
        <v-col md="3"></v-col>
        <v-col md="6">
          <h3 style="text-align:center;color:black;">
            <b>SignUp</b>
          </h3>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              id="firstname"
              v-model="firstname"
              prepend-icon="mdi-account"
              label="First Name"
              type="text"
              :rules="nameRules"
              required
            />

            <v-text-field
              id="lastname"
              v-model="lastname"
              prepend-icon="mdi-account"
              label="Last Name"
              type="text"
              :rules="nameRules"
              required
            />
             <v-radio-group class="prfont cr"
                v-model="gender"
               prepend-icon="mdi-gender-male-female"
                label="Gender"
                row
              >
                <v-radio label="Male"    value="male" class="prfont cr"></v-radio>
                <v-radio label="Female"    value="female" class="prfont cr"></v-radio>
              </v-radio-group>

            <v-menu
              v-model="menu2"
              :rules="dobRules"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :rules="dobRules"
                  v-model="dob"
                  label="Date of Birth"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="dob" @input="menu2 = false"></v-date-picker>
            </v-menu>
            <v-text-field
              id="username"
              v-model="username"
              prepend-icon="mdi-account-circle"
              label="Username"
              type="text"
              required
              :rules="userRules"
            />
            <v-text-field
              id="password"
              v-model="password"
              prepend-icon="mdi-lock"
              label="Password"
              type="password"
              required
              :rules="pwdRules"
            />
            <v-text-field
              id="passwordcnf"
              v-model="passwordcnf"
              prepend-icon="mdi-lock"
              label="Confirm Password"
              type="password"
              required
              :rules="pwdConfirm"
            />
            <v-text-field
              id="phone"
              v-model="phone"
              prepend-icon="mdi-phone"
              label="Phone"
              type="text"
              required
              :rules="phoneRules"
            />
            <v-text-field
              id="email"
              v-model="email"
              prepend-icon="mdi-email"
              label="Email"
              type="email"
              required
              :rules="emailRules"
            />
            <v-text-field
              id="gst"
              v-model="gstid"
              prepend-icon="mdi-hexagon-outline"
              label="gstid"
              type="text"
              :rules="gstRules"
              required
            />
            <v-text-field
              id="address"
              v-model="address1"
              prepend-icon="mdi-dice-3"
              label="Address"
              type="text"
              :rules="address1Rules"
              required
            />
            
            <v-text-field
              id="address2"
              v-model="address2"
              prepend-icon="mdi-dice-3"
              label="Address2"
              type="text"
              required
              :rules="address2Rules"
            />
              <v-text-field
              id="address2"
              v-model="pincode"
              prepend-icon=" mdi-minus-circle-outline"
              label="Pincode"
              type="text"
              :rules="pinRules"
              required
            />

            <v-select v-model="state" :items="states" label="State" dense  prepend-icon="mdi-cash"></v-select>

            <v-select v-model="district" :items="districts" label="District" dense  prepend-icon="mdi-cash"></v-select>
            <v-text-field
              id="address2"
              v-model="country"
              prepend-icon="mdi-dice-3"
              label="Country"
              type="text"
              required
              :rules="countryRules"
            />
          
            <v-layout wrap justify-center>
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  color="#26af82"
                  @click="reginit"
                >SIGNUP</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
import { request } from "http";
export default {
  data() {
    return {
      pwdRules: [v => !!v || "Password required"],
      pwdConfirm: [
        v => !!v || "Confirm password",
        v => v === this.password || "Passwords do not match"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      nameRules: [v => !!v || " required"],
      genderRules: [v => !!v || " required"],
      dobRules: [v => !!v || " required"],
      userRules: [v => !!v || "required"],
      phoneRules: [v => !!v || " is required"],
      address1Rules: [v => !!v || " required"],
      address2Rules: [v => !!v || " required"],
      countryRules: [v => !!v || " required"],
      pinRules: [v => !!v || "required"],
      gstRules: [v => !!v || " required"],
      stateRules: [v => !!v || " required"],
      districtRules: [v => !!v || " required"],

      menu: false,
      opts: [],

      dis: [],
      passwordcnf: "",
      firstname: null,
      lastname: null,
      dob: new Date().toISOString().substr(0, 10),
      gender: 'male',
      username: null,
      password: null,
      phone: null,
      email: null,
      country: null,
      pincode: null,
      address1: null,
      gstid: null,
      address2: null,
      validateselection: null,
      validateselection1: null,
      states: [],
      statesId: [],
      state: null,
      stateId: null,
      districts: [],
      districtsId: [],
      district: null,
      districtId: null,
      isLogedIn: localStorage.getItem("isLoggedIn"),
      menu2: false,
      msg: null,
      itsid: null,
      opts: null
    };
  },

  beforeMount() {
    this.stateList();
  },
  watch: {
    state: function() {
      this.districtList();
    },
    password: function() {
      if (this.password === this.passwordcnf) {
        this.msg4 = "Password Correct";
      } else {
        this.msg4 = "Password doesn't match";
      }
    }
  },
  methods: {
    reginit() {
      if (this.$refs.form.validate()) {
        if (this.state == null) {
          this.msg = "Please select state options";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          this.validateselection = false;
        }

        for (var j = 0; j < this.districts.length; j++) {
          if (this.district == this.districts[j]) {
            this.districtId = this.districtsId[j];
          }
        }
        var datas = {};
        datas["firstname"] = this.firstname;
        datas["lastname"] = this.lastname;
        datas["gender"] = this.gender;
        datas["dob"] = this.dob;
        datas["username"] = this.username;
        datas["password"] = this.password;
        datas["phone"] = this.phone;
        datas["email"] = this.email;
        datas["gstid"] = this.gstid;
        datas["address1"] = this.address1;
        datas["address2"] = this.address2;
        datas["country"] = this.country;
        datas["pincode"] = this.pincode;
        datas["state"] = this.stateId;
        datas["district"] = this.districtId;
        axios({
          method: "POST",
          url: "/user/sellerregister/",
          data: datas
        })
          .then(response => {
            if (response.data.status == true) {
                this.id = response.data.id;
              this.msg = "successfully registered";
              this.$dlg.alert(
                this.msg,
                () => {
                 this.$router.push("/SellerImage/" + this.id);
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
      }
    },
    stateList() {
      // this.dialog = false;

      axios({
        method: "GET",
        url: "/loc/StateList/"
      })
        .then(response => {
          this.states = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.states.length; i++) {
            var ty = this.states[i].name;
            var tyid = this.states[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.states = temp;
          this.statesId = tempid;

          console.log(err);
        })
        .catch(err => {
          this.msg = "Something Went Wrong";
          // alert(err);
          // console.log(err);
        });
    },
    districtList() {
      this.visible = true;
      for (var j = 0; j < this.states.length; j++) {
        if (this.state == this.states[j]) {
          this.stateId = this.statesId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/DistrictList/?stateid=" + this.stateId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.districts = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.districts.length; i++) {
            var ty = this.districts[i].name;
            var tyid = this.districts[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.districts = temp;
          this.districtsId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.hb {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.hh {
  background-color: #ff4e00;
  
}
</style>